import IconButton from './standard';
import IconButtonToggle from './toggle';
export var variants = ['standard', 'filled', 'tonal', 'outlined'];
export { IconButton, IconButtonToggle };
